import styled from 'styled-components';
import { Container, Section } from '../components/ui/Layout';
import SectionHeading from '../components/ui/SectionHeading';
import ReservationForm from '../components/ReservationForm';

const PhoneBar = styled.div`
  max-width: 860px;
  margin: 0 auto 2rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  background: ${({ theme }) => theme.colors.surface};
  padding: 1.1rem 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.16em;

  a {
    background: ${({ theme }) => theme.colors.gold};
    padding: 0.2em 0.6em;
    font-size: 1.05rem;
    letter-spacing: 0.1em;
  }

  a:hover {
    background: ${({ theme }) => theme.colors.pinkSoft};
  }
`;

const OrDivider = styled.p`
  max-width: 860px;
  margin: 0 auto 1.75rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: 1.1rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.text};

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-top: 1px solid ${({ theme }) => theme.colors.text};
  }
`;

function Reservations() {
  return (
    <Section>
      <Container>
        <SectionHeading
          kicker="Aparta tu lugar"
          title="Reservaciones"
          subtitle="Disponibilidad en tiempo real"
          serif="Mesa"
        />
        <PhoneBar>
          <span>Llámanos para reservar tu mesa:</span>
          <a href="tel:+527770000000">777 000 0000</a>
        </PhoneBar>
        <OrDivider>o vía el formulario</OrDivider>
        <ReservationForm />
      </Container>
    </Section>
  );
}

export default Reservations;
